import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import MobileDetect from 'mobile-detect'

import { media, mediaUp } from '@utils/mediaQuery'
import PlayIcon from '@components/svg/PlayIcon'
import VideoLoopDesktop from '@static/videos/intro_final_desktop.mp4'
import VideoLoopMobile from '@static/videos/moon_mobile_720p.mp4'
import LogoLoop from '@static/videos/logo_loop.mp4'
// import VideoPosterDesktop from '@static/videos/intro_final_desktop_poster.png'
import VideoPosterMobile from '@static/videos/intro_final_mobile_poster.png'
import AudioPlayer from '@components/home/AudioPlayer'

const VideoContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 2;
  pointer-events: all;
  background-color: ${props => props.inverted ? '#ffffff' : '#000000'};
  video {
    object-fit: ${props => props.objectFit};
    object-position: ${props => props.objectPosition};
    width: 100vw;
    height: 100vh;
  }
`

const LogoLoopContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 200px;
  height: 80px;
  z-index: 3;
  background: #000;
  transition: opacity 0.5s;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
  opacity: ${props => props.visible ? 1 : 0 };
  ${media.xs`
    padding-top: 10px;
    padding-right: 10px;
    height: 66px;
  `}
  video {
    width: 120px;
    height: 40px;
  }
`

const pulse = keyframes`
  0 {
    transform: scale(1)
  }
  50% {
    transform: scale(1.18)
  }
  100% {
    transform: scale(1)
  }
`

const PlayButton = styled.a`
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 46%;
  width: 4vw;
  cursor: pointer;
  transition: opacity 0.5s;
  opacity: ${props => props.visible ? 1: 0 };
  pointer-events: ${props => props.visible ? 'all': 'none' };
  transform: translate(-50%,-54%);
  ${media.xs`
    width: 4vw;
    left: 45.45%;
    top: 50.45%;
  `}
  ${mediaUp.xxl`
    left: 45.85%;
  `}
  @media (max-height: 800px) and (min-width: 1024px)  {
    /* width: 50px;
    left: calc(45% + 25px); */
  }
  svg {
    width: 100%;
    transition: transform 0.25s;
    animation-name: ${pulse};
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }
  &:hover {
    svg {
      /* transform: scale(1.1); */
      /* animation-name: none; */
    }
  }
`

class VideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canPlay: false,
      playing: false,
      muted: false,
      inverted: false,
      introDone: false,
      objectFit: 'contain',
      objectPosition: 'center center',
      videoSrc: null,
      posterSrc: null,
      mobile: false,
      isIOS: false,
    }
    this.video = React.createRef()
    this.videoSource = React.createRef()
    this.logoVideo = React.createRef()
    this.playButton = React.createRef()
    this.startVideo = this.startVideo.bind(this)
  }

  componentDidMount() {
    if (typeof window == 'object') {
      let md = new MobileDetect(window.navigator.userAgent);

      if (md.mobile() !== null) {
        this.setState({
          mobile: true,
          isIOS : md.is('iPhone'),
        })
      }
    }

    document.addEventListener("visibilitychange", () => {
      if (document.hidden && this.state.playing) {
        this.video.current.pause()
      } else if(this.state.playing) {
        this.video.current.play()
      }
    }, false);

    if (this.video.current) {

      let time = 0

      // pause video first
      this.video.current.pause()
      this.video.current.oncanplay = () => {
        this.setState({
          canPlay: true
        })
      }

      this.video.current.onpause = () => {
        this.setState({
          muted: true,
          playing: false
        })
      }

      this.video.current.onstalled = () => {
        this.setState({
          muted: true,
          playing: false
        })
      }

      this.video.current.onplay = () => {
        this.setState({
          muted: false,
          playing: true
        })
      }

      // interval check for current time
      let currentTimeInterval = setInterval(() => {
        time = this.video.current.currentTime

        // invert first time
        if (time > 3.05) {
          if (!this.state.inverted) {
            this.setState({
              inverted: true
            })
          }
        }

        // moon loop, cover and fit video at the bottom
        if (time > 6.05 && time < 7) {
          if (this.state.inverted) {
            this.logoVideo.current.play()
            this.setState({
              objectFit: 'cover',
              objectPosition: 'bottom center',
              inverted: false,
              introDone: true,
            })
          }
        }

      }, 1)

    }
  }

  startVideo() {
    if (this.video.current) {
      this.video.current.play()
      this.setState({
        playing: true,
        muted: false
      })
    }
  }

  render() {

    return (
      <VideoContainer className={this.props.theme} inverted={this.state.inverted} iOS={this.state.isIOS} objectFit={this.state.objectFit}>
        <PlayButton ref={this.playButton} visible={!this.state.playing} onClick={(e) => this.startVideo()}>
          <PlayIcon />
        </PlayButton>
        <AudioPlayer theme={`dark`} video={this.video} animating={!this.state.muted && this.state.playing} />
        <LogoLoopContainer visible={this.state.introDone}>
          <video ref={this.logoVideo} playsInline loop muted='1'>
            <source src={LogoLoop} type={`video/mp4`} />
          </video>
        </LogoLoopContainer>
          {!this.state.mobile &&
            <video ref={this.video} playsInline>
              <source src={VideoLoopDesktop} type={`video/mp4`} />
            </video>
          }
          {this.state.mobile &&
            <video ref={this.video} playsInline poster={VideoPosterMobile}>
              <source src={VideoLoopMobile} type={`video/mp4`} />
            </video>
          }
      </VideoContainer>
    );
  }
}

export default VideoPlayer;

